import type { Theme } from '@mui/material';

export const styles = {
  button: (theme: Theme) => ({
    color: theme.colors.neutral[500],
    fontWeight: 600,
    fontSize: 14,
  }),
};
